/**
=========================================================
* UF BRAVO Platform
=========================================================

* Copyright 2025 by Jackson Cagle, Fixel Institute
* The source code is made available under a Creative Common NonCommercial ShareAlike License (CC BY-NC-SA 4.0) (https://creativecommons.org/licenses/by-nc-sa/4.0/) 

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import {
  CircularProgress,
  Backdrop
} from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

export default function LoadingProgress() {
  return (
    <Backdrop
      sx={{ color: '#505050ff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
      onClick={() => {}}
    >
      <MKBox display={"flex"} alignItems={"center"} flexDirection={"column"}>
        <MKTypography color={"white"} fontWeight={"bold"} fontSize={30}>
          {"Loading Page..."}
        </MKTypography>
        <CircularProgress color={"info"} />
      </MKBox>
    </Backdrop>
  )
}